
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FAQsService } from '../../../services/FAQsService';

function useFAQsViewHook(t) {
  const params = useParams();
  let id = params.faq_id;
  const navigate = useNavigate();
  const image_url = process.env.REACT_APP_MEDIA_DOMAIN;
  const [data, setData] = useState("");
  const [loader,setLoader]=useState(false);

  useEffect(() => {
    FAQsService.FAQsView(id)
      .then((data) => {
        setLoader(true);
        setData(data.data);
      })
      .catch((error) => {
        console.log("Errorreg", error);
        setLoader(false);
      });
  }, []);

  return {
    data, image_url,loader,navigate
  }
}

export default useFAQsViewHook